import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AttendanceDashboardLayer from "../components/attendance/AttendanceDashboardLayer";

const AttendanceDashboardPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Attendance Dashboard" />
        <AttendanceDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default AttendanceDashboardPage;
